import { library } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin, faTwitter, faFacebook, faInstagram, } from '@fortawesome/free-brands-svg-icons';
import { faAngleRight, faAngleLeft, faAngleDown, faAngleUp, faPhoneAlt, faEnvelope, faMapMarkerAlt, faTimes, faMinus, faPlus } from '@fortawesome/pro-light-svg-icons';
// Build icon library
library.add(faAngleRight, faAngleLeft, faAngleDown, faAngleUp, faPhoneAlt, faEnvelope, faMapMarkerAlt, faTimes, faMinus, faPlus, faLinkedin, faTwitter, faFacebook, faInstagram);
export default library;
